






























































































































































































import draggable from 'vuedraggable';
import { Component, Prop, Ref, Watch, PropSync, Emit } from 'vue-property-decorator';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import Viewpoints from '@/store/modules/Viewpoints';
import Decisions from '@/store/modules/Decisions';
import Choices from '@/store/modules/Choices';
import { VIEWPOINT_API } from '@/api/ViewpointApi';
import { REQUIRED } from '@/rules';
import _ from 'lodash';
import DescriptionEditor from '@/components/common/DescriptionEditor.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

import {
    ResourceList,
    ChoiceList,
    ChoiceListItem,
    ListType,
    ViewpointList,
    ViewpointListItem,
    FactorListItem,
    FactorList,
} from '@/api/model/ResourceList';
import Modelling from '@/store/modules/Modelling';
import { FactorGroup, FactorResource } from '@/api/model/FactorResource';
import FactorNavigationPublishedModel from '@/components/navigation/FactorNavigationPublishedModel.vue';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';

const viewpointsModule = getModule(Viewpoints);
const choicesModule = getModule(Choices);
const decisionsModule = getModule(Decisions);
const modellingModule = getModule(Modelling);
const workspaceOptions = getModule(WorkspaceOptions)
@Component({
    components: {
        DescriptionEditor,
        draggable,
        FactorNavigationPublishedModel,
        ConfirmationDialog
    },
})
export default class FactorListInput extends Vue {
    @Prop({ default: true, type: Boolean })
    show!: boolean;

    // passing list for editing from parent
    @Prop({ default: () => ({}), type: Object })
    listFromParent!: any;

    @Prop({ default: false })
    isEdit!: any;

    @PropSync('save', { default: false, type: Boolean })
    saveSync!: boolean;

    @PropSync('clear', { default: false, type: Boolean })
    clearSync!: boolean;

    @PropSync('loading', { default: false, type: Boolean })
    loadingSync!: boolean;

    @PropSync('saveAsNew', { default: false, type: Boolean })
    saveAsNewSync!: boolean;

    @Watch('saveSync')
    private onSave() {
        if (this.saveSync === true) {
            this.submit();
        }
    }

     @Watch('saveAsNewSync')
    private onSaveAsNew() {
        if (this.saveAsNewSync === true) {
            this.submitAsNew();
        }
    }

    @Watch('clearSync')
    private onClose() {
        if (this.clearSync === true) {
            this.clearForm();
        }
    }

    private REQUIRED = REQUIRED;
    private showLists = true;
    private generating = false;
    private name: string = '';
    private description: string = '';
    private type: any = { FACTOR: 'FACTOR' };
    private loading = false;
    private listId: string = '';
    private alert = false;
    private alertText = 'List Created';
    private alertType = 'success';
    private factorIds: string[] = [];
    private trimNonListFactors = false;
    private panel = [];

    private headers: any[] = [
        { text: 'List Name', value: 'name', sortable: true, width: 160 },
        {
            text: `Number of ${this.pluralFactorLabel}`,
            value: 'numFactors',
            sortable: true,
            width: 160,
        },
        { text: 'Action', value: 'actions', width: 160 },
    ];

    $refs!: {
        form: HTMLFormElement;
        listName: HTMLInputElement;
    };

    mounted() {
        if (this.isEdit && this.listFromParent) {
            this.edit(this.listFromParent);
        }
        this.showLists = this.show;
        // this.displayCreatedLists();
    }

    private getDelTitle(item: any) {
        return 'Delete list - ' + item.name;
    }

    get selectedViewpointIdIndex() {
        return this.choicesList.findIndex((c) => c.id === this.selectedChoiceId);
    }

    get selectedChoiceId() {
        return choicesModule.selectedChoiceId;
    }

    get choicesList() {
        return choicesModule.choicesList;
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get viewpoints() {
        return viewpointsModule.decisionViewpointsMap || [];
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources;
    }

    get isFactorListActive() {
        return workspaceOptions.activeFactorLists.length > 0
    }

    get taskTitle() {
        if (this.listId) {
            return 'Update';
        } else return 'Create';
    }
    get lists() {
        const lists = _.values(decisionsModule.decisionLists).filter(
            (list: ResourceList) => list.type === 'FACTOR'
        );
        return lists;
    }

    get dataTableList() {
        return this.lists
            .map((res: any) => ({
                decisionId: res.decisionId,
                description: res.description,
                factors: res.factors,
                listId: res.listId,
                type: res.type,
                name: res.name,
                numFactors: res.factors.length,
            }));
    }

    get singularFactorLabel() {
        return decisionsModule.singularFactorLabel
    }

    get pluralFactorLabel() {
        return decisionsModule.pluralFactorLabel
    }

    // watch the prop listFromParent
    // will change base on the user's selection
    @Watch('listFromParent', { deep: true })
    editFromParent() {
        if (this.isEdit && this.listFromParent) {
            this.edit(this.listFromParent);
        }
    }

    @Watch('show')
    onShowChange() {
        if (this.show) {
            if (this.isEdit && this.listFromParent) {
                this.edit(this.listFromParent);
            }
            this.reFocus();
        } else {
            this.$refs.form.reset();
        }
        this.trimNonListFactors = false
    }

    async submitAsNew() {
         try {
            if (!this.name || !this.selectedDecision) {
                this.errorMsg('Missing List Name');
                this.loadingSync = false;
                return;
            }
            let factorItemList: FactorListItem[] = [];
            for (let id of this.factorIds) {
                if (this.factorResources[id].type === 'FACTOR_GROUP') {
                    (this.factorResources[id] as FactorGroup)?.groupTypeDefinition?.type ===
                    'TABLE_FIXED'
                        ? (factorItemList = factorItemList.concat(
                              this.getFixedTableIds(this.factorResources[id] as FactorGroup)
                          ))
                        : '';
                }
                factorItemList.push({ factorId: id });
            }

           
            let list: FactorList[] = [
                {
                    factors: factorItemList,
                    decisionId: this.selectedDecision.decisionId,
                    name: this.name,
                    description: this.description,
                    type: this.type.FACTOR,
                    ownerUserId: this.selectedDecision.ownerUserId,
                },
            ];
            await VIEWPOINT_API.createLists(this.selectedDecision.decisionId, list);
            
            this.successMsg('List Created');
            await decisionsModule.getDecisionLists();
            // this.displayCreatedLists();
            if (!this.listFromParent) {
                this.$refs.form.reset();
                this.clearForm();
            }
        } catch (err) {
            this.errorMsg('Failed to Save');
        } finally {
           this.loadingSync = false;
            this.saveAsNewSync = false;
            this.listId = "";
        }
    }

    private async submit() {
        try {
            if (!this.name || !this.selectedDecision) {
                this.errorMsg('Missing List Name');
                this.loadingSync = false;
                return;
            }
            let factorItemList: FactorListItem[] = [];
            for (let id of this.factorIds) {
                if (this.factorResources[id].type === 'FACTOR_GROUP') {
                    (this.factorResources[id] as FactorGroup)?.groupTypeDefinition?.type ===
                    'TABLE_FIXED'
                        ? (factorItemList = factorItemList.concat(
                              this.getFixedTableIds(this.factorResources[id] as FactorGroup)
                          ))
                        : '';
                }
                factorItemList.push({ factorId: id });
            }

            if (this.listId) {
                let list: FactorList = {
                    factors: factorItemList,
                    decisionId: this.selectedDecision.decisionId,
                    name: this.name,
                    description: this.description,
                    type: this.type.FACTOR,
                    listId: this.listId,
                    ownerUserId: this.selectedDecision.ownerUserId,
                };
                await VIEWPOINT_API.putList(this.selectedDecision.decisionId, this.listId, list);
            } else {
                let list: FactorList[] = [
                    {
                        factors: factorItemList,
                        decisionId: this.selectedDecision.decisionId,
                        name: this.name,
                        description: this.description,
                        type: this.type.FACTOR,
                        ownerUserId: this.selectedDecision.ownerUserId,
                    },
                ];
                await VIEWPOINT_API.createLists(this.selectedDecision.decisionId, list);
            }
            this.successMsg('List ' + this.taskTitle + 'd');
            await decisionsModule.getDecisionLists();
            // this.displayCreatedLists();
            if (!this.listFromParent) {
                this.$refs.form.reset();
                this.clearForm();
            }
        } catch (err) {
            this.errorMsg('Failed to Save');
        } finally {
            this.loadingSync = false;
            this.saveSync = false;
        }
    }

    // private async displayCreatedLists() {
    //     if (this.showLists && this.selectedDecision) {
    //         this.loading = true;
    //         this.previousLists = await VIEWPOINT_API.getDecisionLists(
    //             this.selectedDecision.decisionId
    //         );
    //         this.previousLists = this.previousLists.filter(
    //             (list: ResourceList) => list.type === 'FACTOR'
    //         );
    //         this.loading = false;
    //     }
    // }
    @Emit('cancel')
    private cancel() {
        this.clearForm();
    }

    private clearForm() {
        if (this.listFromParent && Object.keys(this.listFromParent).length > 0) {
            this.edit(this.listFromParent);
        } else {
            this.$refs.form.reset();
            this.factorIds=[];
            this.description="";

        }
        this.clearSync = false;
    }

    private edit(list: FactorList) {
        this.factorIds = list.factors.map((factor) => factor.factorId);
        this.name = list.name;
        this.description = list.description;
        this.listId = list.listId ? list.listId : '';
        this.$emit('edit');

    }

    private async delList(list: FactorList) {
        this.loadingSync = true;
        try {
            if (this.selectedDecision && list.listId)
                await VIEWPOINT_API.deleteList(this.selectedDecision.decisionId, list.listId).then(
                    (res) => {
                        decisionsModule.getDecisionLists();
                    }
                );
        } catch (err) {
            console.log(err);
            this.errorMsg('Delete Failed');
        }
        this.loadingSync = false;
    }

    private createAlert() {
        setTimeout(() => {
            this.alert = false;
        }, 2000);
    }

    private reFocus() {
        setTimeout(() => {
            this.$refs.listName.focus();
        }, 500);
    }

    private getFixedTableIds(tableParent: FactorGroup) {
        let factors: string[] = _.uniq(this.getTableGrid(tableParent));

        let returnVals = factors.map((id: string) => {
            if (id != tableParent.id) return { factorId: id };
        });
        return returnVals;
    }

    private orderedRows(tableParent: FactorGroup): FactorGroup[] {
        return tableParent.childrenIds
            .map((f) => this.factorResources[f] as FactorGroup)
            .filter((f) => f && f.groupTypeDefinition.type === 'TABLE_ROW');
    }

    private orderedColumns(tableParent: FactorGroup): FactorGroup[] {
        return tableParent.childrenIds
            .map((f) => this.factorResources[f] as FactorGroup)
            .filter((f) => f && f.groupTypeDefinition.type === 'TABLE_COLUMN');
    }

    private getTableGrid(tableParent: FactorGroup) {
        let grid: any = {};
        let returnFactors: any = [];
        this.orderedColumns(tableParent).forEach((c) => {
            grid[c.id] = {};
            returnFactors.push(c.id);
            this.orderedRows(tableParent).forEach((r) => {
                returnFactors.push(r.id);
                let factorIds = _.intersection(c.childrenIds, r.childrenIds);
                if (factorIds.length === 1) {
                    returnFactors.push(factorIds[0]);
                    grid[c.id][r.id] = factorIds[0];
                }
            });
        });
        return returnFactors;
    }

    private isTableFactor(factor: FactorResource) {
        let allFactors = Object.values(this.factorResources);
        let tableFactors = allFactors.filter(
            (f: any) =>
                f.groupTypeDefinition &&
                f.groupTypeDefinition.type.includes('TABLE') &&
                !f.groupTypeDefinition.type.includes('TABLE_GROWING')
        );
        if (tableFactors.filter((f: any) => f.childrenIds.includes(factor.id)).length > 0)
            return true;
        return (
            (factor as FactorGroup).groupTypeDefinition &&
            ((factor as FactorGroup).groupTypeDefinition.type === 'TABLE_COLUMN' ||
                (factor as FactorGroup).groupTypeDefinition.type === 'TABLE_ROW')
        );
    }

    private successMsg(message: any) {
        this.alert = true;
        this.alertType = 'success';
        this.alertText = message;
        this.createAlert();
    }
    private errorMsg(message: any) {
        this.alert = true;
        this.alertType = 'error';
        this.alertText = message;
        this.createAlert();
    }

    @Watch('selections')
    private onChangeCheckableFactors(value: string[]) {
        this.factorIds = value;
    }
}
